import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/api/client';
import { toast } from 'sonner';

const FILTERS = ['pending', 'approved', 'rejected', 'all'];

function VRStatusBadge({ status }) {
  const cls = status === 'approved' ? 'bg-green-100 text-green-700'
    : status === 'pending' ? 'bg-yellow-100 text-yellow-800'
    : 'bg-red-100 text-red-700';
  return <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${cls}`}>{status}</span>;
}

export default function VolunteersTab() {
  const qc = useQueryClient();
  const [filter, setFilter] = useState('pending');
  const { data = [] } = useQuery({
    queryKey: ['adm-vr', filter],
    queryFn: async () => {
      const params = filter === 'all' ? {} : { status: filter };
      return (await api.get('/admin/volunteer-requests', { params })).data;
    },
  });
  const approve = useMutation({
    mutationFn: async (id) => (await api.put(`/admin/volunteer-requests/${id}/approve`)).data,
    onSuccess: () => { toast.success('Approved'); qc.invalidateQueries(); },
  });
  const reject = useMutation({
    mutationFn: async (id) => (await api.put(`/admin/volunteer-requests/${id}/reject`)).data,
    onSuccess: () => { toast.success('Rejected'); qc.invalidateQueries(); },
  });

  return (
    <div className="space-y-3">
      <div className="flex gap-2 flex-wrap">
        {FILTERS.map((s) => (
          <button key={s} onClick={() => setFilter(s)}
            className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${filter === s ? 'bg-moj-purple text-white' : 'bg-white border border-moj-gold/30'}`}>
            {s}
          </button>
        ))}
      </div>
      <div className="card-moj overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-moj-cream"><tr><th className="text-left p-3">Member</th><th className="text-left p-3">Team</th><th className="text-left p-3">Status</th><th className="p-3">Actions</th></tr></thead>
          <tbody>
            {data.map((v) => (
              <tr key={v.id} className="border-t" data-testid={`vr-row-${v.id}`}>
                <td className="p-3 font-semibold">{v.profile_name}</td>
                <td className="p-3">{v.department}</td>
                <td className="p-3"><VRStatusBadge status={v.status}/></td>
                <td className="p-3">
                  {v.status === 'pending' && (
                    <div className="flex gap-1">
                      <button onClick={() => approve.mutate(v.id)} className="text-xs px-2 py-1 rounded bg-green-600 text-white" data-testid={`vr-approve-${v.id}`}>Approve</button>
                      <button onClick={() => reject.mutate(v.id)} className="text-xs px-2 py-1 rounded bg-red-600 text-white">Reject</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {data.length === 0 && <tr><td colSpan={4} className="text-center p-6 text-moj-charcoal/60">No requests.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
